import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { PersonalInformationSummaryEnergyNeeds } from './PersonalInformationSummaryEnergyNeeds';
import { PersonalInformationSummarySupplyAddress } from './PersonalInformationSummarySupplyAddress';
import { useGetSapQuote } from 'hooks/useGetSapQuote';

const PersonalInformationSummaryContent = () => {
  const getSapQuote = useGetSapQuote();

  const handleClick = async () => {
    try {
      await getSapQuote();
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      <PersonalInformationSummarySupplyAddress />
      <PersonalInformationSummaryEnergyNeeds />
      <NsPrimaryCta onClick={handleClick}>Continue</NsPrimaryCta>
    </>
  );
};

export default PersonalInformationSummaryContent;
